import { render, staticRenderFns } from "./los.vue?vue&type=template&id=b9e90212&scoped=true&"
var script = {}
import style0 from "./los.vue?vue&type=style&index=0&id=b9e90212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e90212",
  null
  
)

export default component.exports